"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Users";

export default {
  getCurrentUser() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetCurrentUser`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  getAllUsers() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllUsers`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveUser(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveUser`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  getOneUserData(userId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetOneUserData`, `?userID=${userId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteUser(userId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteUser?userID=${userId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  checkUserValidity(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/CheckUserValidity`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  changePassword(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/ChangePassword`, payload).result.then(
        ({ data }) => resolve(data)
      );
    });
  },
  userActivityLog(userID) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/getUserActivityLog`, `?userID=${userID}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
